import { render } from "./AyudaBiomAten.vue?vue&type=template&id=8d140294&scoped=true"
import script from "./AyudaBiomAten.vue?vue&type=script&lang=js"
export * from "./AyudaBiomAten.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=8d140294&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d140294"]])

export default __exports__